<template>
  <div>
    <div class="tips-container">
      <span>提示：</span>
      <span>①支持"手工录入"和"上传发票"（OCR发票自动识别）两种方式录入。</span>
      <span>
        ②「上传发票」自动识别和读取发票文件，电子版支持PDF、OFD和XML格式、纸质版支持JPG、PNG、JPEG格式，单个文件大小限制7M，最多同时上传5个文件。
      </span>
      <span>③发票提交成功后，【电子发票】无需再发送邮箱，纸质发票还需要贴票邮寄。</span>
      <span>④当天开具的发票需在开出后24小时再上传。</span>
    </div>
    <el-form :inline="true" :model="paymentOrderForm" class="button-on-right">
      <el-form-item label="付款单：">
        <el-input style="width: 220px" v-model="paymentOrderForm.paymentOrderId" disabled />
      </el-form-item>
      <el-form-item label="付款单金额合计(元)：">
        <el-input v-model="paymentOrderForm.paymentOrderAmount" disabled />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          :disabled="!selectedRows.length"
          style=" margin-right: 16px;"
          @click="batchDelete"
          >批量删除发票</el-button
        >
        <el-upload
          ref="invoiceUpload"
          action=""
          multiple
          :limit="5"
          :auto-upload="false"
          :show-file-list="false"
          :on-exceed="handleFileExceed"
          :on-change="handleFileChange"
          style="display: inline-block; margin-right: 16px;"
        >
          <el-button type="primary" :loading="OCRLoading">上传发票</el-button>
        </el-upload>
        <el-button type="primary" @click="confirm" :loading="confirmLoading">确定</el-button>
      </el-form-item>
    </el-form>
    <el-row class="margin-b-10">
      <!--      <el-col style="color: red" :span="20">{{ checkErrors }}</el-col>-->
      <el-col style="color: red" :span="20">
        <div>{{ checkErrors }}</div>
      </el-col>
    </el-row>
    <div class="invoice-table-container">
      <el-form ref="invoiceTableForm" :model="invoiceTableForm">
        <el-table
          @selection-change="handleSelectionChange"
          :data="invoiceTableForm.invoiceTableData"
          height="400"
          border
          style="width: 100%"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column
            v-for="(col, index) in invoiceColumns"
            :key="index"
            :prop="col.prop"
            :label="col.label"
            :fixed="col.fixed"
            :min-width="!col.width ? 110 : null"
            :label-class-name="col.required ? 'prop-required' : ''"
            :width="col.width"
          >
            <template slot-scope="scope">
              <!--操作列单元格-->
              <div v-if="col.type === 'operation'">
                <el-button type="text" @click="deleteInvoice(scope.row)">删除</el-button>
              </div>
              <el-form-item
                v-else
                :prop="`invoiceTableData.${scope.$index}.${col.prop}`"
                :rules="embedRowInFormRules(col.rules, scope.row)"
                style="margin: 0;"
              >
                <!--不可编辑状态的单元格-->
                <div v-if="!scope.row.isEditable">
                  <!--对不可编辑的发票类型单元格的特殊处理，因为发票类型在不可编辑时需要显示发票类型名称，而不是发票类型编号-->
                  <span v-if="col.prop === 'invoiceType'">{{ scope.row.invoiceTypeName }}</span>
                  <!--其他不可编辑状态下的单元格-->
                  <span v-else>{{ scope.row[col.prop] }}</span>
                </div>
                <!--以下是可编辑状态的单元格-->
                <el-select
                  v-else-if="col.type === 'select'"
                  style="width: 100%;"
                  v-model="scope.row[col.prop]"
                  placeholder="请选择"
                  @change="col.onchange(scope.row)"
                >
                  <el-option
                    v-for="item in col.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <el-date-picker
                  v-else-if="col.type === 'date'"
                  style="width: 100%;"
                  v-model="scope.row[col.prop]"
                  type="date"
                  placeholder="请选择"
                  value-format="yyyy-MM-dd"
                  prefix-icon="none"
                  clear-icon="none"
                  :picker-options="pickerOptions"
                  class="data-picker-thin"
                />
                <mtd-input
                  v-else-if="col.type === 'input'"
                  style="width: 100%;"
                  v-model.trim="scope.row[col.prop]"
                  :placeholder="shouldInputDisabled(scope.row, col.prop) ? '' : '请输入'"
                  :disabled="shouldInputDisabled(scope.row, col.prop)"
                  @change="val => onInputChange(val, col.prop, scope.row)"
                />
                <!-- 手动上传附件：41-区块链电子发票 42-机打发票 43-可报销其他发票 -->
                <div v-else-if="col.type === 'a'">
                  <template v-if="scope.row[col.prop] && scope.row[col.linkProp]">
                    <a :href="scope.row[col.linkProp]" target="_blank">
                      {{ scope.row[col.prop] }}
                    </a>
                    <i
                      v-if="customFileRequiredTypes.includes(scope.row.invoiceType)"
                      style="cursor: pointer;"
                      class="mtdicon mtdicon-error-o"
                      @click="deleteExtraFile(scope.row)"
                    ></i>
                  </template>
                  <BikeUpload
                    v-else-if="customFileRequiredTypes.includes(scope.row.invoiceType)"
                    ref="fileUploader"
                    :size="20"
                    :limit="1"
                    :showTip="false"
                    :isPreview="false"
                    validateFileType
                    accept=".jpg, .png, .pdf,"
                    btnType="text-primary"
                    btnText="上传附件"
                    uploadUrl="/api/bff/external/common/upload/signatureUrl/associate"
                    signatureUrl="/api/bff/external/common/upload/getUploadSignPrivate/associate"
                    @change="files => getUploadFile(files, scope.row)"
                  >
                    <div style="font-size: 12px;color:#564d4d">(小于20M jpg/png/pdf)</div>
                  </BikeUpload>
                </div>
                <span v-else-if="col.type === 'index'">
                  {{ scope.$index + 1 }}
                </span>
                <span v-else>{{ scope.row[col.prop] }}</span>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <el-button type="primary" @click="addManualInvoiceRow" class="add-button">新增</el-button>
    </div>
  </div>
</template>

<script>
import {
  INVOICE_TYPE,
  columns,
  invoiceTypeList,
  shouldInputDisabled,
  customFileRequiredTypes,
  amountEditabledTypes,
} from './default'
import { computeAdd } from '@/utils'

export default {
  name: 'InvoiceEnter',
  props: {
    payOrderIdList: {
      type: Array,
      required: true,
    },
    payOrderAmountList: {
      type: Array,
      required: true,
    },
    addedInvoiceNoList: {
      type: Array,
      default: () => {
        return []
      },
    },
    taxRate: {
      type: String,
      required: true,
    },
    serverCheckErrors: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      customFileRequiredTypes,
      invoiceTableForm: {
        invoiceTableData: [],
      },
      selectedRows: [],
      invoiceColumns: columns,
      uploadDebounceTimer: null,
      OCRLoading: false,
      confirmLoading: false,
      checkErrors: '',
      pickerOptions: {
        disabledDate(time) {
          // 禁用当天及以后
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          return time.getTime() >= today.getTime()
        },
      },
    }
  },
  beforeDestroy() {
    // 清除定时器
    if (this.uploadDebounceTimer) {
      clearTimeout(this.uploadDebounceTimer)
    }
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval)
    }
  },
  computed: {
    // computedCheckErrors() {
    //
    //   return <p>{{this.checkErrors}}</p>  + '\n' + this.serverCheckErrors
    // },
    paymentOrderForm() {
      return {
        paymentOrderId: this.payOrderIdList.join('、'),
        paymentOrderAmount: this.payOrderAmountList.reduce(computeAdd),
      }
    },
  },
  watch: {
    'invoiceTableForm.invoiceTableData'() {
      this.checkErrors = ''
    },
    serverCheckErrors(n) {
      this.checkErrors = n.slice(9)
    },
  },
  methods: {
    shouldInputDisabled,
    /**
     * 发票表格相关
     */
    embedRowInFormRules(rules, row) {
      // 把row放到el-form表单验证的参数中，让校验方法可以获取表单所处的row
      rules = rules || []
      return rules.map(rule => {
        return {
          ...rule,
          row,
        }
      })
    },
    batchDelete() {
      this.selectedRows.forEach(item => {
        this.deleteInvoice(item)
      })
    },
    handleSelectionChange(val) {
      this.selectedRows = val
    },
    addManualInvoiceRow() {
      this.$refs.invoiceTableForm.clearValidate()
      const row = { isEditable: true }
      // 新增行时不设置初始空值的列
      const excludeColProps = ['operation', 'amount']
      this.invoiceColumns
        .filter(col => !excludeColProps.includes(col.prop))
        .forEach(col => {
          row[col.prop] = ''
        })
      this.defineRowProperties(row)
      this.invoiceTableForm.invoiceTableData.unshift(row)
      this.$nextTick(() => {
        // 避免新增行上显示校验错误信息
        this.$refs.invoiceTableForm.clearValidate()
      })
    },
    defineRowProperties(row) {
      Object.defineProperties(row, {
        amount: {
          get: () => {
            return row._amount
          },
          set: value => {
            row._amount = value
          },
          enumerable: true,
          configurable: true,
        },
        taxAmount: {
          get: () => {
            return row._taxAmount
          },
          set: value => {
            if (
              !this.isInputMoneyStrValid(value) ||
              parseFloat(value) < 0 ||
              parseFloat(value) > 10000000
            ) {
              return
            }
            row._taxAmount = value
          },
          enumerable: true,
          configurable: true,
        },
        unTaxAmount: {
          get: () => {
            return row._unTaxAmount
          },
          set: value => {
            if (
              !this.isInputMoneyStrValid(value) ||
              parseFloat(value) < 0 ||
              parseFloat(value) > 10000000
            ) {
              return
            }
            row._unTaxAmount = value
          },
          enumerable: true,
          configurable: true,
        },
        invoiceTypeName: {
          get: () => {
            const invoiceType = invoiceTypeList.find(type => type.value === row.invoiceType)
            return invoiceType ? invoiceType.label : ''
          },
          enumerable: true,
          configurable: true,
        },
      })
    },
    deleteInvoice(row) {
      const index = this.invoiceTableForm.invoiceTableData.indexOf(row)
      this.invoiceTableForm.invoiceTableData.splice(index, 1)
      this.$refs.invoiceTableForm.clearValidate()
    },
    /**
     * OCR发票相关
     */
    handleFileExceed() {
      this.$message.error('一次最多上传5个文件')
    },
    handleFileChange(file, fileList) {
      // 最后一次上传的文件onChange时设置的timer负责进行校验和上传
      clearTimeout(this.uploadDebounceTimer)
      this.uploadDebounceTimer = setTimeout(() => {
        this.uploadDebounceTimer = null
        // 校验和上传
        if (this.isFileTypeAcceptable(fileList)) {
          this.submitFile(fileList)
        } else {
          this.$refs.invoiceUpload.clearFiles()
        }
      }, 100)
    },
    isFileTypeAcceptable(fileList) {
      const hasOverSize = fileList.some(file => file.size > 7 * 1024 * 1024)
      const hasUnacceptedType = fileList.some(file => {
        const ext = file.name.split('.').pop()
        return !['pdf', 'ofd', 'xml', 'jpg', 'png', 'jpeg'].includes(ext.toLowerCase())
      })
      if (hasOverSize) {
        this.$message.error('单个文件大小大于7m')
      } else if (hasUnacceptedType) {
        this.$message.error('文件格式不符合，请查看提示')
      }
      return !hasOverSize && !hasUnacceptedType
    },
    async submitFile(fileList) {
      this.OCRLoading = true
      this.$message.success('正在识别发票内容，请稍候')
      const deadline = Date.now() + 1000 * 20
      const formData = new FormData()
      fileList.forEach(file => {
        formData.append('files', file.raw)
      })
      this.fetch
        .post('uploadInvoiceFileHella', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          const { requestNos } = res.data || {}
          this.pollingOCRResults(requestNos || [], deadline, 250)
        })
        .catch(e => {
          this.OCRLoading = false
          console.log(e)
        })
        .finally(() => {
          this.$refs.invoiceUpload.clearFiles()
        })
    },
    async pollingOCRResults(pendingInvoiceNos, deadline, step) {
      // 在ddl前每隔step毫秒查询一次，如果step到达时上一个查询还未完成，则跳过本次查询
      let prevQuery = null
      let abortPolling = false
      const pollingInterval = setInterval(() => {
        if (Date.now() > deadline || abortPolling) {
          if (prevQuery) {
            // 等待最后一个查询完成
            return
          } else {
            // 超时或出错
            this.$message.error('发票识别失败，请重新上传')
            clearInterval(pollingInterval)
            this.OCRLoading = false
            return
          }
        }
        if (!prevQuery) {
          query()
        }
      }, step)
      const query = () => {
        const params = { requestNos: pendingInvoiceNos.join(',') }
        prevQuery = this.fetch
          .get('getInvoiceResultHella', { params })
          .then(res => {
            const { requestNoCount, invoiceVOs } = res.data || {}
            if (requestNoCount === pendingInvoiceNos.length) {
              const ocrInvoiceList = (invoiceVOs || []).map(invoiceOCRData => {
                const row = {
                  ...invoiceOCRData,
                  isEditable: true,
                }
                row._taxAmount = row.taxAmount
                row._unTaxAmount = row.unTaxAmount
                row._amount = this.calAmout(row)
                // 为了兼容手动修改的情况，价税合计永远是计算得到的，忽略接口返回值
                this.defineRowProperties(row)
                return row
              })
              this.invoiceTableForm.invoiceTableData.unshift(...ocrInvoiceList)
              // 查询成功则立即退出，不会进入下一个interval
              clearInterval(pollingInterval)
              this.OCRLoading = false
            }
          })
          .catch(e => {
            abortPolling = true
            console.log(e)
          })
          .finally(() => {
            prevQuery = null
          })
      }
    },
    // 计算价税合计
    calAmout(row) {
      if (amountEditabledTypes.includes(row.invoiceType)) return ''
      // 空字符串在isInputMoneyStrValid中被认为是有效的，所以这里要单独判断
      if (row.unTaxAmount === '' || row.taxAmount === '') {
        return ''
      }
      if (
        !this.isInputMoneyStrValid(row.unTaxAmount) ||
        !this.isInputMoneyStrValid(row.taxAmount)
      ) {
        return ''
      }
      const res = computeAdd(row.unTaxAmount, row.taxAmount)
      return isNaN(res) ? '' : String(res)
    },
    isInputMoneyStrValid(str) {
      // 保证
      // 1. 不符合金额规则的字符串不通过
      // 2. 从空字符串开始输入，到一个带小数点的金额，再反过来删到空字符串的过程中，不被校验打断
      // 等价 /^\d+(\.\d{1,2})?$/.test(str) || /^\d+(\.)?$/.test(str) || str === ''
      return /^(\d+(\.(\d{1,2})?)?)?$/.test(str)
    },
    /**
     * 提交结果相关
     */
    confirm() {
      this.$refs.invoiceTableForm.validate((isValid, invalidList) => {
        // 必填项校验由表单完成
        if (isValid) {
          // 税率校验和重复校验
          if (this.hasNoDuplication()) {
            // 43类型发票税率与付款单税率一致
            const invoiceData = this.invoiceTableForm.invoiceTableData.map(row => {
              if (row.invoiceType === INVOICE_TYPE.OTHER_REIMBURSABLE) {
                return { ...row, taxRate: this.taxRate }
              }
              return row
            })
            this.$emit('confirm', invoiceData)
          }
        } else {
          const msg = invalidList[Object.keys(invalidList)[0]][0].message || '校验失败'
          this.$message.error(msg)
        }
      })
    },
    hasNoDuplication() {
      let isValid = true
      this.checkErrors = ''
      // 过滤掉41、42、43类型的发票
      const filteredInvoiceData = this.invoiceTableForm.invoiceTableData.filter(
        item =>
          ![
            INVOICE_TYPE.BLOCKCHAIN,
            INVOICE_TYPE.MACHINE_PRINTED,
            INVOICE_TYPE.OTHER_REIMBURSABLE,
          ].includes(item.invoiceType)
      )
      const noList = filteredInvoiceData.map(item => item.invoiceNo)
      if (this.hasDuplication(noList)) {
        this.checkErrors = this.getDuplicationErrStr(noList)
        // this.$message.error('发票号码重复录入')
        isValid = false
      } else if (this.hasDuplication(noList.concat(this.addedInvoiceNoList))) {
        this.checkErrors = this.getUsedInvoiceErrStr(noList, this.addedInvoiceNoList)
        // this.$message.error('发票号码已被使用，请重新录入')
        isValid = false
      }
      return isValid
    },
    hasDuplication(arr) {
      return new Set(arr).size !== arr.length
    },
    getUsedInvoiceErrStr(curArr, usedArr) {
      const ret = []
      for (let i = 0; i < curArr.length; i++) {
        if (usedArr.includes(curArr[i])) {
          ret.push(i + 1)
        }
      }
      return `【错误提示】如下序号的发票已被使用，请重新录入：${ret.join()}`
    },
    getDuplicationErrStr(arr) {
      const map = new Map()
      const ret = []
      for (let i = 0; i < arr.length; i++) {
        if (!map.has(arr[i])) {
          map.set(arr[i], [i + 1])
        } else {
          map.get(arr[i]).push(i + 1)
        }
      }

      for (const val of map.values()) {
        if (val.length > 1) {
          ret.push(val)
        }
      }

      let str = ''
      for (const item of ret) {
        str += `[${item.join()}] `
      }

      return `【错误提示】如下序号的发票重复录入：${str}`
    },
    onInputChange(val, prop, row) {
      console.log('onInputChange', val, prop, row)
      if (['unTaxAmount', 'taxAmount'].includes(prop)) {
        row._amount = this.calAmout(row)
      }
    },
    getUploadFile(files, row) {
      const file = (files && files[0]) || {}
      row.fileName = file.name
      row.fileUrl = file.url
      // 触发表单校验以清除错误提示
      this.$refs.invoiceTableForm.validate()
    },

    // 删除附件
    deleteExtraFile(row) {
      row.fileName = ''
      row.fileUrl = ''
    },
  },
}
</script>

<style scoped lang="scss">
.tips-container {
  padding: 4px 8px;
  margin-bottom: 18px;
  background-color: #ffec9f;
  border-radius: 4px;
  span {
    display: block;
  }
}
.button-on-right {
  display: flex;
  flex-wrap: wrap;
  .el-form-item:last-child {
    margin-right: 0;
    margin-left: auto;
  }
}
// 不能直接写prop-required，因为th和div都被赋了这个class
::v-deep .prop-required div::before {
  content: '*';
  color: #f56c6c;
}
.invoice-table-container {
  position: relative;
  .add-button {
    position: absolute;
    top: 7px;
    right: 4px;
    padding: 6px 12px;
  }
}
.data-picker-thin {
  ::v-deep input {
    padding: 0 10px;
  }
}
</style>
